module.exports = __webpack_public_path__ + "img/Sacombank_DKDKSuDungUuDaiGolf-hình ảnh-4.ecebb14c.jpg";